import {DateAdapter, MAT_DATE_FORMATS} from "@angular/material/core";
import {CUSTOM_DATE_TIME_FORMAT} from "../formats/custom-date.format";
import {CustomDateTimeAdapter} from "../../adapters/custom-date-time.adapter";

export const customDateTimeProvider = [
  {
    provide: DateAdapter,
    useClass: CustomDateTimeAdapter
  },
  {
    provide: MAT_DATE_FORMATS,
    useValue: CUSTOM_DATE_TIME_FORMAT
  }
];
